import { render, staticRenderFns } from "./InternalHotelSearchBox.vue?vue&type=template&id=60eaa1f4&"
import script from "./InternalHotelSearchBox.vue?vue&type=script&lang=js&"
export * from "./InternalHotelSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GIT\\Web-Solutions\\IPA.Naga.Web\\Themes\\Eavar.com.V2\\UINew\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60eaa1f4')) {
      api.createRecord('60eaa1f4', component.options)
    } else {
      api.reload('60eaa1f4', component.options)
    }
    module.hot.accept("./InternalHotelSearchBox.vue?vue&type=template&id=60eaa1f4&", function () {
      api.rerender('60eaa1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Js/Services/Tourism/HotelDestination/InternalHotelSearchBox.vue"
export default component.exports